"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureFlagsCreateConfig = void 0;
exports.featureFlagsCreateConfig = {
    canCreateFeatureFlags: true,
    showCreateFeatureFlagButton: true,
};
